import axios from "axios";
import config from "../config";

const MerchandiseService = {
  list(id) {
    return new Promise((resolve, reject) => {
      axios
        .get(`${config("API_URL")}merchandise/${id}/list`)
        .then(response => {
          resolve(response.data);
        })
        .catch(err => {
          reject(err);
        });
    });
  },
  create(orderId, merchData) {
    return new Promise((resolve, reject) => {
      axios
        .put(`${config("API_URL")}merchandise/${orderId}/create`, merchData)
        .then(response => {
          resolve(response.data);
        })
        .catch(err => {
          reject(err);
        });
    });
  },
  getMerch(orderId) {
    return new Promise((resolve, reject) => {
      axios
        .get(`${config("API_URL")}merchandise/${orderId}`)
        .then(response => {
          resolve(response.data);
        })
        .catch(err => {
          reject(err);
        });
    });
  }
};
export default MerchandiseService;



// WEBPACK FOOTER //
// ./services/MerchandiseService.js